export default __webpack_public_path__ + "assets/information-circle--information-frame-info-more-help-point-circle.png";